import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/* eslint-disable no-console */
import axios from 'axios';

class Brightcove {
  constructor(autobahnBaseUrl = '') {
    this.autobahnBaseUrl = autobahnBaseUrl;
  }

  getDictionaryTermVideoId(dictionaryTermTag) {
    var _this = this;

    return _asyncToGenerator(function* () {
      const url = `${_this.autobahnBaseUrl}/api/brightcove/videos?limit=100&q=product_id:${dictionaryTermTag}`;
      const data = yield axios.get(url, {
        crossDomain: true
      });
      const _data$data = data.data,
            count = _data$data.count,
            videos = _data$data.videos;

      if (count > 0) {
        return videos[0].id;
      }

      const msg = `Brightcove: no video found for dictionaryTermTag "${dictionaryTermTag}"`;
      console.error(msg);
      throw msg;
    })();
  }

  getVideo(videoName) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      const url = `${_this2.autobahnBaseUrl}/api/brightcove/videos?limit=100&q=product_id:${videoName}`;
      const data = yield axios.get(url, {
        crossDomain: true
      });
      const _data$data2 = data.data,
            count = _data$data2.count,
            videos = _data$data2.videos;

      if (count > 0) {
        return videos[0];
      }

      const msg = `Brightcove: no video found for videoName using product_id field "${videoName}"`;
      console.error(msg);
      throw msg;
    })();
  }

  getVideos(productId) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      const url = `${_this3.autobahnBaseUrl}/api/brightcove/videos?limit=100&q=tags:${productId}`;
      const data = yield axios.get(url, {
        crossDomain: true
      });
      const videos = data.data.videos;
      return videos;
    })();
  }

}

export default Brightcove;